export function detectBrowser() {
  const isChromium = window.chrome;
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isOpera = winNav.userAgent.indexOf('OPR') > -1;
  const isIEedge = winNav.userAgent.indexOf('Edge') > -1;
  const isIOSChrome = winNav.userAgent.match('CriOS');

  const isFirefox = winNav.userAgent.toLowerCase().indexOf('firefox') > -1;
  const isSafari = winNav.userAgent.indexOf('Safari') > -1;
  const isCamino = winNav.userAgent.indexOf('Camino') > -1;
  const isIE = !!winNav.userAgent.match(/Trident/g) || !!winNav.userAgent.match(/MSIE/g);

  const isEdge = /Edge\/\d./i.test(navigator.userAgent);

  if (isIOSChrome) {
    return 'Chrome';
  } else if (
    isChromium !== null &&
    typeof isChromium !== 'undefined' &&
    vendorName === 'Google Inc.' &&
    isOpera === false &&
    isIEedge === false
  ) {
    return 'Chrome';
  }
  if (isEdge) {
    return 'Edge';
  }
  if (isFirefox) {
    return 'Firefox';
  }
  if (isSafari) {
    return 'Safari';
  }
  if (isOpera) {
    return 'Opera';
  }
  if (isCamino) {
    return 'Camino';
  }
  if (isIE) {
    return 'IE';
  }
  return 'Undefined Browser';
}



// WEBPACK FOOTER //
// ./src/utils/detectBrowser.js